import {inlineError, streamify} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
@streamify('execute')
class GetNavigationLinksAdsUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Object} deps.getNavigationLinksSearchService
   * @param {Object} deps.navigationLinksRequestValueObjectFactory
   */
  constructor({config, getNavigationLinksSearchService, navigationLinksRequestValueObjectFactory}) {
    super()

    this._config = config
    this._service = getNavigationLinksSearchService
    this._navigationLinksRequestValueObjectFactory = navigationLinksRequestValueObjectFactory
  }

  /**
   * @return {Promise<Object, Error>} Navigation links (previous ad url, next ad url, back to ads list url)
   */
  @inlineError
  async execute({id, currentPosition = 0}) {
    const NAVIGATION_TYPES = this._config.get('NAVIGATION_TYPES')
    const navigationLinksRequestValueObject = this._navigationLinksRequestValueObjectFactory({
      currentPosition,
      id,
      type: NAVIGATION_TYPES.ADS
    })
    return this._service
      .execute(navigationLinksRequestValueObject)
      .then(([navigationLinksError, navigationLinksValueObject]) => {
        if (navigationLinksError) return Promise.reject(navigationLinksError)
        return navigationLinksValueObject.toJSON()
      })
  }
}

export {GetNavigationLinksAdsUseCase}
